<template>
  <div>
    <el-drawer title="新增出库计划" direction="ltr" :visible.sync="addPlanBillVisible" :before-close="addPlanClose"
      size="45%">
      <el-form :inline="true" label-width="90px" style="margin-top:20px;" size="small" ref="addBillForm"
        class="demo-form-inline" :model="addBillForm" :rules="rules">
        <el-form-item label="一级货主:" prop="primaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.primaryCustomerTaxId" filterable placeholder="请选择"
            style="width:170px" size="mini" @change="primaryCustomerTaxIdChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:" prop="secondaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.secondaryCustomerTaxId" :disabled='dissecondaryCustomerTaxId'
            filterable placeholder="请选择" style="width:170px" size="mini" @change="secondaryCustomerChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户单号:" prop="outBillNo">
          <el-input v-model="addBillForm.outBillNo" maxlength="50" placeholder="请输入客户单号" style="width:170px"
            size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="addBillForm.remark" maxlength="100" :rows="1" style="width:200px;">
          </el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left:10px;">
        <div>人车信息 </div>
        <hr>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
          style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column label="提货车号" width="150">
            <template slot="header">
              <div><span class="red">*</span>提货车号</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-autocomplete class="inline-input" v-model.trim="subTableData[scope.$index].plateNumber" size="mini"
                  :fetch-suggestions="querySearch" value-key="plateNumber" @select="handleSelect($event,scope.$index)"
                  popper-class="xiala">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.plateNumber }},{{ item.driverName }}</div>
                    <span class="addr">{{ item.idNumber? item.idNumber:''}}</span>
                  </template>
                </el-autocomplete>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.driverName" placeholder="请输入姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.idNumber" placeholder="请输入司机身份证号"
                @blur="idInput(scope.row.idNumber)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.telephone" placeholder="请输入司机联系电话"
                @blur="phoneInput(scope.row.telephone)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="selectSiji(scope.row,scope.$index)" type="text" size="small">选择司机</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.surplus">
                  <span style="margin-left:20px;">货权剩余：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span
                        style="color:red">{{item.surplusControlWeight}}</span><span> 吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span
                        style="color:red">{{item.surplusControlNumber}}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
              <div style="margin-right:20px;">
                <el-button type="primary" size="mini" @click="delClick(item,ix)">删除</el-button>
              </div>
            </div>
          </div>
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list"
            style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="操作" width="100">
              <template slot-scope="scope1">
                <el-button @click="tabDelClick(item,scope1.$index,ix)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="number" align="center" label="件数" width="100">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.number" @blur="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0" maxlength="50" placeholder="输入件数" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="allWeight" align="center" label="重量（吨）" width="100">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.allWeight" v-number-input.float="4" maxlength="50" placeholder="输入重量"
                  size="mini" :disabled='scope1.row.flag == "理重"' @blur="weightInput(scope1.row,scope1.row.allWeight)">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="stockAvailableNumber" align="center" label="库存可提"></el-table-column>
            <el-table-column prop="cmAvailableNumber" align="center" label="客户可提"></el-table-column>
            <el-table-column prop="vehicleNumber" align="center" label="车船号"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格" width="150"></el-table-column>
            <el-table-column prop="placeOfOrigin" align="center" label="产地" width="120"></el-table-column>
            <el-table-column prop="productName" align="center" label="货物类型" width="120"></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width="150"></el-table-column>
            <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
            <el-table-column prop="stockWeight" align="center" label="总重量(吨)" width="150"></el-table-column>
            <el-table-column prop="shipForecastNo" align="center" label="预报编号" width="200"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="finishClick(1)" :loading='addLoading'>保存</el-button>
        <el-button type="primary" :loading="confirmLoadingB" @click="finishClick(2)">保存并打印</el-button>
      </div>
      <el-drawer title="添加货物" :modal-append-to-body="false" size="100%" :visible.sync="addPlanBillVisible"
        :modal="false" :before-close="addPlanClose" class="rightDrawer">
        <div style="margin:22px 0 0 10px;">
          <span style="font-size:15px;">车船号：</span>
          <el-select v-model="cheChuanNum" clearable filterable placeholder="请选择" style="width:170px;" size="mini">
            <el-option v-for="(item,index) in plateNumberData" :key="index" :label="item.plateNumber"
              :value="item.plateNumber"></el-option>
          </el-select>
          <span style="font-size:15px;margin-left:10px;">规格：</span>
          <el-select v-model="specification" clearable filterable placeholder="请选择" style="width:170px;" size="mini">
            <el-option v-for="(item,index) in specificationData" :key="index" :label="item.specification"
              :value="item.specification"></el-option>
          </el-select>
          <el-button type="primary" size="mini" @click="searchClick" style="margin-left:8px;">查询</el-button>
          <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
        </div>
        <div style="margin:10px 0 0 10px;">
          <el-table size="mini" :data="detailsDataCopyAdd" ref="detailsDataCopyAdd" style="width:100%;"
            :header-cell-style="{background:'#f5f5f5'}" @row-click="dianjixuanzhong" highlight-current-row>
            <el-table-column prop="inStockTime" align="center" label="入库时间" width="190"></el-table-column>
            <el-table-column prop="stockAvailableNumber" align="center" label="库存可提"></el-table-column>
            <el-table-column prop="cmAvailableNumber" align="center" label="客户可提"></el-table-column>
            <el-table-column prop="vehicleNumber" align="center" label="车船号"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <el-table-column prop="placeOfOrigin" align="center" label="产地"></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型"></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width="150"></el-table-column>
            <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
            <el-table-column prop="stockNumber" align="center" label="件数"></el-table-column>
            <el-table-column prop="stockWeight" align="center" label="总重量（吨）" width="120"></el-table-column>
            <el-table-column prop="avgWeight" align="center" label="件重(吨/件)" width="120"></el-table-column>
            <el-table-column prop="shipForecastNo" align="center" label="预报编号" width="200"></el-table-column>
          </el-table>
          <!--分页-->
          <div class="pags" style="text-align: right">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageNo"
              :page-size="pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeXQ" :total="total"></el-pagination>
          </div>
        </div>
      </el-drawer>

    </el-drawer>
    <select-siji v-if="selectSijiVisible" :table.sync="selectSijiVisible" @selectDriver="selectDriver"></select-siji>
  </div>
</template>

<script>
  import {
    getRelationCustomer, // 字典客户
    JfgetTEmptyBillDriverList, // 取得人车信息
    JfgetEmptyBillStockWarehouse, // 添加出库计划 添加货物列表（来源手动）
    JfvirtualControlBean, // 调用控货接口
    getWeighingMethodList, // 判断计重方式
    JfgetTEmptyStockCustomerGroup,
    addEmptyOutstockJanFaForSummary, // 添加出库计划确定
    getDriverList,
    getSpecificationListForSummary,
    getPlateNumberListForSummary,
    getTStockSummaryList
  } from '@/api/wms-stock.js'
  import SelectSiji from '../SelectSiji'
  const vhsrule =
    /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
  const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
  const phonerule = /^[1]([3-9])[0-9]{9}$/

  export default {
    components: {
      SelectSiji
    },
    name: 'XinzengTidan',
    data() {
      return {
        subTableData: [],
        detailsDataCopyAdd: [],
        billId: '',
        plateNumberOption: [],
        xuanzhongArr: null,
        organizationId: localStorage.getItem('tenantCode'),
        allDataList: [],
        searchArr: [],
        parentData: {},
        jianShuArr: [],
        addLoading: false,
        confirmLoadingB: false,
        paramsObject: {},
        addBillForm: {
          primaryCustomerTaxId: '',
          primaryCustomerName: '',
          secondaryCustomerTaxId: '',
          secondaryCustomerName: '',
          outBillNo: '',
          carHoldFalg: '',
          remark: '',
          billId: '', // 出库提单id
          outstockId: '' // 出库单id
        },
        customerData: [], // 货主数据
        rules: {
          primaryCustomerTaxId: [{
            required: true,
            message: '请选择一级货主',
            trigger: 'change'
          }],
          secondaryCustomerTaxId: [{
            required: true,
            message: '请选择二级货主',
            trigger: 'change'
          }]
        },
        dissecondaryCustomerTaxId: true,
        TableIndex: 0,
        selectSijiVisible: false,
        carDerList: [],
        specificationData: [],
        specification: '',
        plateNumberData: [],
        cheChuanNum: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    },
    props: {
      addPlanBillVisible: {
        type: Boolean,
        default: true
      },
      planData: {
        type: Object
      },
      chePai: {
        type: String
      }
    },
    watch: {
      planData: {
        deep: true,
        immediate: true,
        handler(val) {
          if (val) {
            this.parentData = val
            this.addBillForm.primaryCustomerTaxId = val.primaryCustomerTaxId
            this.addBillForm.secondaryCustomerTaxId = val.secondaryCustomerTaxId
            this.billId = val.billId
            // this.organizationId = val.organizationId
          }
        }
      }
    },
    created() {
      var _this = this
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {
          _this.finishClick(2)
        }
      }
    },
    mounted() {
      this.driverData()
      this.getStockWarehouse()
      this.getRelationCustomer()
      getDriverList().then(res => {
        this.carDerList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose() {}
        })
      })
    },
    methods: {
      // 获取规格下拉框数据
      getSpecificationListForSummary() {
        getSpecificationListForSummary({
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId // （二级货主id 必填）
        }).then(res => {
          this.specificationData = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      // 获取车船号下拉框数据
      getPlateNumberListForSummary() {
        getPlateNumberListForSummary({
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId // （二级货主id 必填）
        }).then(res => {
          this.plateNumberData = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      searchClick() {
        this.getTStockSummaryList()
      },
      chongZhi() {
        this.specification = ''
        this.cheChuanNum = ''
        this.getTStockSummaryList()
      },
      // 获取右边列表
      getTStockSummaryList() {
        getTStockSummaryList({
          pageNo: this.pageNo, // （必填）
          pageSize: this.pageSize, // （必填）
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id 必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
          specification: this.specification, // （规格 非必填）
          plateNumber: this.cheChuanNum // （车船号 非必填）
        }).then(res => {
          this.detailsDataCopyAdd = res.list
          this.total = res.total
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      handleCurrentChangeXQ(val) {
        this.pageNo = val
        this.getTStockSummaryList()
      },
      handleSizeChangeXQ(val) {
        this.pageSize = val
        this.getTStockSummaryList()
      },
      // 获取一级、二级客户
      getRelationCustomer() {
        getRelationCustomer().then(res => {
          this.customerData = res // 客户
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      // 一级货主下拉框改变
      primaryCustomerTaxIdChange() {
        this.addBillForm.secondaryCustomerTaxId = ''
        this.dissecondaryCustomerTaxId = false
        this.delClick()
      },
      // 二级货主下拉框值改变
      secondaryCustomerChange() {
        // 调取右侧添加货物接口
        this.getSpecificationListForSummary()
        this.getPlateNumberListForSummary()
        this.getTStockSummaryList()
        this.delClick()
      },
      selectSiji(row, index) {
        this.TableIndex = index
        this.selectSijiVisible = true
      },
      selectDriver(row) {
        this.$set(this.subTableData[this.TableIndex], 'driverName', row.name)
        this.$set(this.subTableData[this.TableIndex], 'telephone', row.mobile)
        this.$set(this.subTableData[this.TableIndex], 'idNumber', row.identityNo)
      },
      querySearch(str, cb) {
        let arr = []
        this.carDerList.forEach(itme => {
          if (str) {
            if (itme.plateNumber.indexOf(str) != -1) {
              arr.push(itme)
            }
          } else {
            arr.push(itme)
          }
        })
        cb(arr)
      },
      handleSelect(row, index) {
        this.$set(this.subTableData[index], 'driverName', row.driverName)
        this.$set(this.subTableData[index], 'telephone', row.telephone)
        this.$set(this.subTableData[index], 'idNumber', row.idNumber)
      },
      driverData() {
        let obj = {
          plateNumber: '',
          driverName: '',
          idNumber: '',
          telephone: '',
          billDriverId: ''
        }
        this.subTableData.push(obj)
      },
      // 点击
      dianjixuanzhong(row) {
        this.xuanzhongArr = {}
        this.xuanzhongArr = row
        this.JfvirtualControlBean()
        this.getWeighingMethod()
      },
      delClick(item, ix) {
        this.allDataList.splice(ix, 1)
      },
      tabDelClick(item, ix, index) {
        item.list.forEach((item1, index1) => {
          if (index1 == ix) {
            item.list.splice(ix, 1)
            if (item.list.length == 0) {
              item.num = 0
              item.sumWeight = 0
              this.delClick(item, index)
            } else {
              this.allDataList.forEach((item, index) => {
                this.$set(item, 'num', item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.number / 1
                }, 0))
                this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.allWeight / 1
                }, 0)).toFixed(4))
              })
            }
          }
        })
      },
      // 添加出库计划取消
      addPlanClose() {
        this.$emit('update:addPlanBillVisible', false)
        this.$parent.xztableData = []
      },
      // 出库提单 取得人车信息
      getDriverList() {},
      // 获取添加货物列表
      getStockWarehouse() {
        JfgetEmptyBillStockWarehouse({
          billId: this.billId
        }).then(res => {
          this.detailsDataCopyAdd = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      // 判断计重方式
      getWeighingMethod() {
        getWeighingMethodList({
          productType: this.xuanzhongArr.productType
        }).then(res => {
          if (res[0].outWeighingMethod == 1) {
            this.$set(this.xuanzhongArr, 'disWeight', true)
          } else {
            this.$set(this.xuanzhongArr, 'disWeight', false)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      // 调用控货接口
      JfvirtualControlBean() {
        JfvirtualControlBean({
          oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
          twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
          organizationId: this.organizationId, // （仓储租户id  必填）
          productionPlaceName: this.xuanzhongArr.placeOfOrigin, // （产地  必填）
          specificationName: this.xuanzhongArr.specification, // （规格  必填）
          materialName: this.xuanzhongArr.model, // （材质  必填）
          goodTypeName: this.xuanzhongArr.productName // （货物类型名称  必填
        }).then(res => {
          // controlPiece: 1  // 控件  0不控  1控
          // controlWeight: 1 // 控吨  0不控  1控
          // isEnable: 1    //控货不控货标识   1控  2不控
          if (res) {
            let isEnableObj = {}
            isEnableObj = JSON.parse(res)
            this.$set(this.xuanzhongArr, 'number', '')
            this.$set(this.xuanzhongArr, 'weight', '')
            this.$set(this.xuanzhongArr, 'allWeight', '')
            this.$set(this.xuanzhongArr, 'productTypeName', this.xuanzhongArr.productName)
            this.$set(this.xuanzhongArr, 'billDetailId', this.xuanzhongArr.billDetailId)
            // 控货
            if (isEnableObj.isEnable == '1') {
              // let str = `${isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '_'}${isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '_'}${isEnableObj.specificationName ? isEnableObj.specificationName : '_'}${isEnableObj.materialName ? isEnableObj.materialName : ''}`
              let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
                (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
                (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
                (isEnableObj.materialName ? isEnableObj.materialName : '')
              if (str == ',,,') {
                str = '总控'
              }
              this.$set(this.xuanzhongArr, 'cargoControlKey', str)
              if (this.allDataList.some(item => item.cargoControlKey == str)) {
                let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
                this.allDataList[index].list.push(this.xuanzhongArr)
                this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
              } else {
                let obj = {
                  cargoControlKey: str,
                  releaseFlag: 0,
                  list: [],
                  num: 0,
                  sumWeight: 0,
                  surplus: true,
                  surplusControlWeight: isEnableObj.surplusControlWeight,
                  surplusControlNumber: isEnableObj.surplusControlNumber,
                  controlWeight: isEnableObj.controlWeight,
                  controlPiece: isEnableObj.controlPiece,
                  strictReminder: isEnableObj.strictReminder,
                  isEnable: isEnableObj.isEnable
                }
                obj.list.push(this.xuanzhongArr)
                this.allDataList.push(obj)
              }
            } else {
              // 不控
              this.$set(this.xuanzhongArr, 'cargoControlKey', '不控货')
              if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
                let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
                this.allDataList[index].list.push(this.xuanzhongArr)
                this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
              } else {
                let obj = {
                  cargoControlKey: '不控货',
                  list: [],
                  num: 0,
                  sumWeight: 0,
                  surplus: false
                }
                obj.list.push(this.xuanzhongArr)
                this.allDataList.push(obj)
              }
            }
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      changeJianShu(row, val) {
        console.log(row.shipForecastNo,'row')
        if (val) {
          if (row.number / 1 > row.stockAvailableNumber / 1) {
            this.$message.error('所输入的件数不能大于库存可提件数')
            this.$set(row, 'weight', '')
            this.$set(row, 'allWeight', '')
          } else {
            if (row.flag == '理重') {
              this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
              this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
            } else {
              this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
              // 1）有入库预报，按入库预报实入平均件重，取单件重量
              // 2）无入库预报，按入库平均件重，，取单件重量
              if (row.shipForecastNo !== '' && row.shipForecastNo !== undefined) {
                this.$set(row, 'allWeight', (row.number / 1 * row.estimatedSingletonWeight).toFixed(4))
              } else {
                this.$set(row, 'allWeight', (row.number / 1 * row.inAvgWeight).toFixed(4))
              }
            }
          }
        } else {
          this.$set(row, 'weight', '0.000')
          this.$set(row, 'allWeight', '0.000')
        }
        this.allDataList.forEach((item, index) => {
          this.$set(item, 'num', item.list.reduce((pre, cur) => {
            return pre / 1 + cur.number / 1
          }, 0))
          this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
            return pre / 1 + cur.allWeight / 1
          }, 0)).toFixed(4))
        })
      },
      weightInput(row, val) {
        row.allWeight = Number(val).toFixed(4)
        this.allDataList.forEach(item => {
          this.$set(item, 'num', item.list.reduce((pre, cur) => {
            return pre / 1 + cur.number / 1
          }, 0))
          this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
            return pre / 1 + cur.allWeight / 1
          }, 0)).toFixed(4))
        })
      },
      finishClick(n) {
        if (this.allDataList.length == 0) {
          this.$message.error('请选择右侧数据填写货物信息再点击保存')
        } else {
          // let chepai = this.subTableData.some(item => !vhsrule.test(item.plateNumber))
          let idCard = this.subTableData.some(item => !idrule.test(item.idNumber) && item.idNumber != '')
          let phoneCard = this.subTableData.some(item => !phonerule.test(item.telephone) && item.telephone != '')
          if (this.subTableData[0].plateNumber == '') {
            this.$message({
              message: '车牌号不能为空',
              type: 'error'
            })
          } else if (idCard) {
            this.$message({
              message: '身份证号不正确',
              type: 'error'
            })
          } else if (phoneCard) {
            this.$message({
              message: '手机号不正确',
              type: 'error'
            })
          } else {
            let flagA = this.allDataList.every(item => item.num / 1 != 0)
            if (!flagA) {
              this.$message.error('件数不能为空或0')
              return
            }
            let flagB = true
            this.allDataList.forEach(item => {
              flagB = item.list.every(im => !!im.number || !!im.allWeight)
            })
            if (!flagB) {
              this.$message.error('信息填写不完整')
              return
            }
            let flagC = true
            this.allDataList.forEach(item => {
              flagC = item.list.every(im => im.allWeight / 1 > 0)
            })
            if (!flagC) {
              this.$message.error('重量不能为0或者小于0')
              return
            }
            if (flagA && flagB && flagC) {
              // if (this.subTableData[0].billDriverId == '' || this.subTableData[0].billDriverId == null || this.subTableData[0].billDriverId == undefined) {
              //   this.$message.error('非提单维护的完整车牌号不能保存')
              // } else {
              this.addBillForm.primaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
                .addBillForm.primaryCustomerTaxId)[0].custerName
              this.addBillForm.secondaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
                .addBillForm.secondaryCustomerTaxId)[0].custerName
              this.paramsObject = {
                tEmptyOutstockMaster: {
                  // billId: this.billId,
                  primaryCustomerName: this.addBillForm.primaryCustomerName, // （一级货主名称  必填）
                  primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
                  customerName: this.addBillForm.secondaryCustomerName, // （二级货主名称  必填）
                  customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
                  outstockPlateNumber: this.subTableData[0].plateNumber, // （出库车牌号  必填）
                  outBillNo: this.addBillForm.outBillNo, // （客户单号 必填 来源提单主表）
                  // billDriverId: this.subTableData[0].billDriverId, // （提单司机id 必填）
                  driverName: this.subTableData[0].driverName, // （司机姓名  必填）
                  carHoldFalg: '0', // （扣车标记 0：不扣，1：扣车 必填）
                  telephone: this.subTableData[0].telephone, // （司机手机 非必填）
                  idNumber: this.subTableData[0].idNumber, // （身份证号 非必填）
                  remark: this.addBillForm.remark // （出库单备注 非必填）
                },
                queryList: this.allDataList
              }
              this.recursionCheck(0, n)
              // }
            }
          }
        }
      },
      // 调接口
      addOutStock(n) {
        if (n == '1') {
          this.addLoading = true
        } else {
          this.confirmLoadingB = true
        }
        addEmptyOutstockJanFaForSummary(this.paramsObject).then(res => {
          if (n == '1') {
            this.addLoading = false
            this.$emit('update:addPlanBillVisible', false)
            this.$message.success('添加成功')
            this.addPlanClose()
            this.$emit('chaxun')
          } else {
            this.confirmLoadingB = false
            this.$emit('update:addPlanBillVisible', false)
            this.$message.success('添加成功')
            this.addPlanClose()
            this.$router.push({
              path: '/yycZhuangCheDan',
              query: {
                id: res
              }
            })
          }
        }).catch(err => {
          if (n == '1') {
            this.addLoading = false
          } else {
            this.confirmLoadingB = false
          }
          if (err.code == '-200') {
            this.$message.error(JSON.parse(err.message).msg)
            let cargoControlKey = JSON.parse(err.message).cargoControlKey
            if (cargoControlKey != '不控货') {
              let paramsObj = {}
              if (cargoControlKey == '总控') {
                paramsObj = {
                  oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                  twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                  organizationId: this.organizationId // （仓储租户id  必填） tenantCode
                }
              } else {
                let controlKeyArr = cargoControlKey.split(',')
                paramsObj = {
                  oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                  twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                  organizationId: this.organizationId, // （仓储租户id  必填）
                  productionPlaceName: controlKeyArr[0], // （产地  必填）
                  goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                  specificationName: controlKeyArr[2], // （规格  必填）
                  materialName: controlKeyArr[3] // （材质  必填）
                }
              }
              JfvirtualControlBean(paramsObj).then(res => {
                let isEnableObjB = JSON.parse(res)
                for (let index = 0; index < this.allDataList.length; index++) {
                  if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                    this.allDataList[index].surplusControlWeight = isEnableObjB.surplusControlWeight
                    this.allDataList[index].surplusControlNumber = isEnableObjB.surplusControlNumber
                  }
                }
              }).catch(err => {
                this.$message.error(err.message)
              })
            }
          } else {
            this.$message.error(err.message)
          }
        })
      },
      // 递归调用
      recursionCheck(index, n) {
        if (index < 0) {
          return
        }
        if (index == this.allDataList.length) {
          this.addOutStock(n)
        }
        if (index > this.allDataList.length) {
          // todo
        }
        const item = this.allDataList[index]
        // if (item) {
        if (item.isEnable == '1') {
          // 严控
          if (item.strictReminder == '0') {
            if (item.controlPiece == '1' && item.controlWeight == '1') {
              if (item.num > item.surplusControlNumber || item.sumWeight > item.surplusControlWeight) {
                this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于货权剩余量')
              } else {
                this.recursionCheck(index + 1, n)
              }
            } else if (item.controlPiece == '1') { // 控件
              if (item.num > item.surplusControlNumber) {
                this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              } else {
                this.recursionCheck(index + 1, n)
              }
            } else if (item.controlWeight == '1') { // 控吨
              if (item.sumWeight > item.surplusControlWeight) {
                this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量')
              } else {
                this.recursionCheck(index + 1, n)
              }
            }
          } else {
            // 提示
            if (item.controlPiece == '1' && item.controlWeight == '1') {
              if (item.num > item.surplusControlNumber) {
                this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
                return
              }
              if (item.sumWeight > item.surplusControlWeight) {
                console.log('999')
                this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                  confirmButtonText: '继续',
                  cancelButtonText: '取消',
                  closeOnClickModal: false,
                  type: 'warning'
                }).then(() => {
                  item.releaseFlag = 1
                  console.log(item.cargoControlKey, item.releaseFlag)
                  this.recursionCheck(index + 1, n)
                  console.log('D')
                }).catch(() => {})
              } else {
                this.recursionCheck(index + 1, n)
              }
            } else if (item.controlPiece == '1') {
              if (item.num > item.surplusControlNumber) {
                this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              } else {
                this.recursionCheck(index + 1, n)
              }
            } else if (item.controlWeight == '1') {
              console.log('控吨')
              if (item.sumWeight > item.surplusControlWeight) {
                this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                  confirmButtonText: '继续',
                  cancelButtonText: '取消',
                  closeOnClickModal: false,
                  type: 'warning'
                }).then(() => {
                  item.releaseFlag = 1
                  console.log(item.cargoControlKey, item.releaseFlag)
                  this.recursionCheck(index + 1, n)
                  console.log('D')
                }).catch(() => {})
              } else {
                this.recursionCheck(index + 1, n)
                console.log('E')
              }
            }
          }
        } else {
          // this.addOutStock(n)
          this.recursionCheck(index + 1, n)
        }
        // }
      }
    }
  }

</script>

<style scoped lang='less'>
  .xiala {
    .name {
      color: #000;
      line-height: normal;
      margin-top: 6px;
    }

    .addr {
      color: #999;
    }
  }

</style>
